import { CLOSED, ONGOING } from "./colors";
import { DateField, TextField } from "react-admin";

import Card from "./card";
import { DATE_RANGE_EXPR } from "../components/inputs/DateRangeInput";
import DeviceField from "./fields/DeviceField";
import DurationField from "./fields/DurationField";
import Filters from "./Filters";
import InfoField from "./fields/InfoField";
import NotesField from "./fields/NotesField";
import React from "react";
import ResponsiveGrid from "../components/list/ResponsiveGrid";
import ResponsiveList from "../components/list/ResponsiveList";
import { Typography } from "@material-ui/core";
import compose from "recompose/compose";
import useIsAdmin from "../useIsAdmin";
import { withStyles } from "@material-ui/core";

const all = DATE_RANGE_EXPR["all"]();

const rowStyles = (theme) => ({
  bordered: {
    borderLeftWidth: 5,
    borderLeftStyle: "solid",
    "& td:first-child": {
      borderLeftWidth: 5,
      borderLeftStyle: "solid",
    },
    "& td:first-child span": {
      marginLeft: -3,
    },
  },
  ongoing: {
    borderLeftColor: ONGOING,
    "& td:first-child": {
      borderLeftColor: ONGOING,
    },
  },
  closed: {
    borderLeftColor: CLOSED,
    "& td:first-child": {
      borderLeftColor: CLOSED,
    },
  },
});

const rowClasses = (record, classes) => {
  return [
    classes.bordered,
    record.closed !== null ? classes.closed : classes.ongoing,
  ];
};

const EmailSendField = ({ record = {} }) => {
  return <Typography>{record.email_send?.num_email || "-"}</Typography>;
};
EmailSendField.defaultProps = {
  label: "Num Email",
  source: "email_send.num_email",
};

const GroupNameField = ({ record = {} }) => {
  return <Typography>{record.groups?.group_name || "-"}</Typography>;
};
GroupNameField.defaultProps = {
  label: "Group Name",
  source: "groups.group_name",
};

const List = ({ classes, innerSidebarOpen, ...props }) => {
  const isAdmin = useIsAdmin(props);

  const params = new URLSearchParams(props.location.search);
  let filterValues = {};
  try {
    const filterString = params.get("filter");
    filterValues = filterString ? JSON.parse(filterString) : {};
  } catch {
    filterValues = {};
  }

  const showEmailGroupFields = filterValues.max_email_send === true;

  const additionalProps = {};
  if (!isAdmin) {
    additionalProps.bulkActionButtons = false;
  }
  return (
    <ResponsiveList
      {...props}
      {...additionalProps}
      filters={<Filters />}
      filterDefaultValues={{
        ...all,
        view: "all",
        is_ongoing: true,
        is_closed: false,
      }}
      perPage={10}
      sort={{ field: "end_at", order: "DESC" }}
      type="card"
    >
      <ResponsiveGrid
        rowClick="show"
        rowClasses={(record) => rowClasses(record, classes)}
        rowBreakpoint="md"
        cardContent={<Card />}
        cardClasses={(record) => rowClasses(record, classes)}
      >
        <TextField source="id" />
        <InfoField source="location" sortBy="location.tree_name" />
        <DeviceField source="device" sortBy="device.code" />
        <NotesField source="notes" />
        {showEmailGroupFields && (
          <EmailSendField label="resources.event.fields.email.send" />
        )}
        {showEmailGroupFields && <GroupNameField label="app.group" />}
        <DateField
          source="end_at"
          showTime={true}
          label="resources.event.fields.last_update"
        />
        <DateField
          source="start_at"
          showTime={true}
          label="resources.event.fields.start_at"
        />
        <DateField source="closed" showTime={true} />
        <DurationField source="duration" variant="body2" />
      </ResponsiveGrid>
    </ResponsiveList>
  );
};
export default compose(withStyles(rowStyles))(List);
